/**
 * Video Testimonials Modal
 */

export function initVideoModal() {
    var videoModal = document.getElementById('videoModal');
    if (!videoModal) return;

    var videoPoster = document.getElementById('video-poster');
    var videoIframe = document.getElementById('video-iframe');
    var videoElement = document.getElementById('video-element');
    var posterImage = document.getElementById('poster-image');
    var closeButtons = document.querySelectorAll('.video-modal-close, .btn-close, .video-modal-overlay');
    var videoPlayButtons = document.querySelectorAll('.video-play-button');

    // Check if URL is a direct video file (mp4, webm, etc.)
    function isDirectVideoFile(url) {
        if (!url) return false;
        var videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.m4v'];
        var lowerUrl = url.toLowerCase();
        return videoExtensions.some(function(ext) {
            return lowerUrl.indexOf(ext) > -1;
        });
    }

    // Check if URL is YouTube or Vimeo embed
    function isEmbedVideo(url) {
        if (!url) return false;
        return url.indexOf('youtube.com') > -1 || 
               url.indexOf('youtu.be') > -1 || 
               url.indexOf('vimeo.com') > -1;
    }

    function openVideoModal(videoUrl, posterImageUrl) {
        if (!videoUrl) return;

        // Show poster initially
        if (posterImageUrl && posterImage) {
            posterImage.src = posterImageUrl;
            if (videoPoster) videoPoster.style.display = 'flex';
        }
        
        // Reset both video elements
        if (videoIframe) {
            videoIframe.style.display = 'none';
            videoIframe.src = '';
        }
        if (videoElement) {
            videoElement.style.display = 'none';
            videoElement.src = '';
            videoElement.pause();
        }

        videoModal.style.display = 'flex';
        videoModal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        setTimeout(function() {
            // Handle direct video files (mp4, webm, etc.) - use HTML5 video element
            if (isDirectVideoFile(videoUrl)) {
                if (videoElement) {
                    videoElement.src = videoUrl;
                    videoElement.style.display = 'block';
                    videoElement.load();
                    
                    // Play video with sound (iOS requires user interaction which we have from click)
                    var playPromise = videoElement.play();
                    if (playPromise !== undefined) {
                        playPromise.then(function() {
                            if (videoPoster) videoPoster.style.display = 'none';
                        }).catch(function(error) {
                            console.log('Autoplay prevented:', error);
                            // Show controls so user can manually play
                            if (videoPoster) videoPoster.style.display = 'none';
                        });
                    }
                }
            }
            // Handle YouTube/Vimeo embeds - use iframe
            else if (videoIframe && videoUrl) {
                var autoplayUrl = videoUrl;
                var separator = videoUrl.indexOf('?') > -1 ? '&' : '?';
                
                // YouTube
                if (videoUrl.indexOf('youtube.com') > -1 || videoUrl.indexOf('youtu.be') > -1) {
                    autoplayUrl = videoUrl + separator + 'autoplay=1&playsinline=1&rel=0';
                }
                // Vimeo
                else if (videoUrl.indexOf('vimeo.com') > -1) {
                    autoplayUrl = videoUrl + separator + 'autoplay=1&playsinline=1';
                }
                // Other embeds
                else {
                    autoplayUrl = videoUrl + separator + 'autoplay=1&playsinline=1';
                }
                
                videoIframe.src = autoplayUrl;
                videoIframe.style.display = 'block';
                videoIframe.addEventListener('load', function onLoad() {
                    setTimeout(function() {
                        if (videoPoster) videoPoster.style.display = 'none';
                    }, 500);
                    videoIframe.removeEventListener('load', onLoad);
                }, { once: true });
            }
        }, 100);
    }

    function closeVideoModal() {
        if (videoIframe) {
            videoIframe.src = '';
            videoIframe.style.display = 'none';
        }
        if (videoElement) {
            videoElement.pause();
            videoElement.src = '';
            videoElement.style.display = 'none';
        }
        if (videoPoster) videoPoster.style.display = 'flex';

        videoModal.style.display = 'none';
        videoModal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
    }

    videoPlayButtons.forEach(function(button) {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var videoItem = this.closest('.video-testimonial-item');
            if (videoItem) {
                var videoUrl = videoItem.getAttribute('data-video-url');
                var posterImageUrl = videoItem.getAttribute('data-poster-image');
                if (videoUrl) openVideoModal(videoUrl, posterImageUrl);
            }
        });
    });

    closeButtons.forEach(function(button) {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            closeVideoModal();
        });
    });

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && videoModal.style.display === 'flex') {
            closeVideoModal();
        }
    });
}

